import { render, staticRenderFns } from "./MessageTip.vue?vue&type=template&id=2d5faf08&scoped=true"
import script from "./MessageTip.vue?vue&type=script&lang=js"
export * from "./MessageTip.vue?vue&type=script&lang=js"
import style0 from "./MessageTip.vue?vue&type=style&index=0&id=2d5faf08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5faf08",
  null
  
)

export default component.exports